import React from "react";
import { InfoIcon, ArrowRightIcon } from "lucide-react";
import { projectIncludes, audience, skillPath } from "../../data/content";
export function Solution() {
  return <section className="bg-forest py-16 text-ivory md:py-24" data-id="element-199" data-mp="7npz8wmd89p">
      <div className="mx-auto max-w-wrap px-5 md:px-8" data-id="element-200" data-mp="98g8mbwi51r">
        <div className="mx-auto max-w-[780px] text-center" data-id="element-201" data-mp="3rdfbfuzgbwq6">
          <h2 className="heading text-[46px] md:text-[72px]" data-id="element-202" data-mp="3rg1fvlr1pw46">
            Bagmaking <span className="text-sand" data-id="element-203" data-mp="96r7i8g51fm3">Ready</span>
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-ivory/85 md:text-lg" data-id="element-204" data-mp="49sczoskb6nd">
            A 40-page manual that takes you from fabric to finished bag. Pick a project, cut the pieces from the table,
            follow the illustrated sequence — and end up with a bag you made yourself.
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-[900px] rounded-2xl border border-white/15 bg-forest-deep p-6 md:p-8" data-id="element-205" data-mp="rzv1jux9puh8">
          <h3 className="m-0 text-center text-xs font-bold uppercase tracking-[0.16em] text-sand" data-id="element-206" data-mp="nyt49jmwvshw">Build your skills bag by bag</h3>
          <ol className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-3" data-id="element-207" data-mp="1vwt4gvxm07p5">
            {skillPath.map((step, i) => <li key={step} className="flex items-center gap-2" data-id="element-208" data-mp="24uvdnyrhy6ni" data-mpi={i}>
                <span className="rounded-full bg-cream px-3.5 py-1.5 text-sm font-semibold text-forest" data-id="element-209" data-mp="29u804ieghbpk">{step}</span>
                {i < skillPath.length - 1 && <ArrowRightIcon className="h-4 w-4 text-sand" aria-hidden="true" data-id="element-210" data-mp="2esjb4wghls9d" />}
              </li>)}
          </ol>
        </div>

        <h3 className="mt-12 text-center text-xs font-bold uppercase tracking-[0.16em] text-sand" data-id="element-211" data-mp="2isjqcjbeu7hh">Every bag project includes</h3>
        <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4" data-id="element-212" data-mp="2sl8vyxka4r4w">
          {projectIncludes.map(item => <div key={item.title} className="rounded-2xl border border-white/15 bg-forest-soft p-5 md:p-6" data-id="element-213" data-mp="2xl3ot6nm7qsl">
              <div className="heading text-[26px] text-sand md:text-[30px]" data-id="element-214" data-mp="32jeynhdwu1at">{item.title}</div>
              <p className="mb-0 mt-2 text-sm leading-snug text-ivory/80" data-id="element-215" data-mp="2cvjcmhg0za7h">{item.body}</p>
            </div>)}
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2.5" data-id="element-216" data-mp="27tk8v6gdiba0">
          {audience.map(a => <span key={a} className="rounded-full border border-sand/60 px-4 py-2 text-sm font-medium text-ivory" data-id="element-217" data-mp="2mmdzno13idtz">
              {a}
            </span>)}
        </div>

        <div className="mx-auto mt-10 flex max-w-[780px] gap-3 rounded-2xl border border-white/15 bg-forest-deep p-5 text-[15px] leading-relaxed text-ivory/85" data-id="element-218" data-mp="2vjeizg9b5lqk">
          <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-sand" aria-hidden="true" data-id="element-219" data-mp="35joxd472wz7b" />
          <p className="m-0" data-id="element-220" data-mp="30jstd4ydt7rr">
            <strong className="text-cream" data-id="element-221" data-mp="30lncqeu08rtq">Good to know:</strong> projects use rectangular pieces you measure and cut
            from the tables provided — full-size printable pattern sheets are not included. This is not a course on
            learning to use a sewing machine.
          </p>
        </div>
      </div>
    </section>;
}